"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImportResponseMetadata = exports.ImportResponseDto = exports.ImportValidationResponseDto = void 0;
class ImportValidationResponseDto {
}
exports.ImportValidationResponseDto = ImportValidationResponseDto;
class ImportResponseDto {
}
exports.ImportResponseDto = ImportResponseDto;
// Instead of passing back all data of imported records, we can just pass back metadata.
// For backwards compatibility, use ImportResponseDto<ImportResponseMetadata> and set
// data to an array of one ImportResponseMetadata object.
class ImportResponseMetadata {
}
exports.ImportResponseMetadata = ImportResponseMetadata;
//# sourceMappingURL=import.dto.js.map